const isImageFile = (name) => {
  const fileName = name ? name.toLowerCase() : ''
  return (fileName.endsWith('.jpg') || fileName.endsWith('.png') || fileName.endsWith('.jpeg'))
}

export {
  isImageFile
}